import { Button } from "@/components/ui/button";
import { TypingSubtitle } from "./TypingSubtitle";
import { PhoneMockup } from "./PhoneMockup";
import { motion } from "framer-motion";
import { MovingBorderWrapper } from "@/components/ui/moving-border";
export function Hero() {
  return <section className="relative pt-24 lg:pt-12 pb-2 lg:pb-3 overflow-hidden">

      <div className="container mx-auto px-6 lg:px-12 xl:px-20 relative z-10 h-full">
        <div className="grid lg:grid-cols-[1fr,1.2fr] gap-8 lg:gap-12 xl:gap-16 items-center h-full">
          {/* Left: Text content */}
          <div className="max-w-2xl lg:max-w-3xl lg:pt-8 text-center lg:text-left mx-auto lg:mx-0">
            {/* H1 Title */}
            <h1 className="text-3xl sm:text-4xl lg:text-[2.85rem] xl:text-[3.1rem] font-bold lg:leading-[1.05] leading-tight text-foreground mb-6">
               Envoyez du contenu directement sur<br className="sm:hidden" />{" "}
               <span className="text-[#0C94A6]">l'écran verrouillé</span>{" "}<span className="whitespace-nowrap text-[#0C94A6]">de votre audience</span>.
             </h1>

            {/* Typing Subtitle */}
            <div className="min-h-[3.5rem] lg:min-h-[4rem] mb-[10px]">
              <TypingSubtitle />
            </div>

            {/* Problem / Solution Text */}
            <p className="leading-relaxed mb-8 font-medium text-[#4f5b5d] pt-0 mt-0 text-base sm:text-lg lg:text-[1.18rem]">
              Les emails se perdent, les algorithmes filtrent.<br className="hidden lg:inline" />{" "}<span className="font-semibold text-[#0C94A6]">Unotif</span> permet d'atteindre jusqu'à 95% de visibilité<br className="hidden lg:inline" />{" "}avec des notifications impossibles à manquer.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 items-center sm:items-start justify-center lg:justify-start">
              <div className="flex flex-col items-center lg:items-start">
                <MovingBorderWrapper duration={3000} borderRadius="0.5rem">
                  <Button asChild size="lg" className="bg-primary hover:bg-[hsl(187,87%,32%)] text-primary-foreground shadow-lg hover:shadow-xl transition-all duration-300 text-base px-8 py-6">
                    <a href="https://app.unotif.com/auth?mode=signup">
                      Commencer gratuitement
                    </a>
                  </Button>
                </MovingBorderWrapper>
                <p className="text-sm font-medium text-muted-foreground mt-2">
                  👉 Aucune carte bancaire requise
                </p>
              </div>
              <Button variant="outline" size="lg" asChild className="border-primary/30 text-primary hover:bg-primary/5 hover:border-primary text-base px-6 py-6 font-medium">
                <a href="https://app.unotif.com/auth?mode=signin">
                  J'ai déjà un compte
                </a>
              </Button>
            </div>
          </div>

          {/* Right: Phone Mockup - 3D perspective, centered behind blob */}
          <div className="hidden lg:flex justify-center lg:justify-end items-center pr-4 lg:pr-8">
            {/* Inner wrapper - fit-content + relative for exact blob centering */}
            <div className="relative w-fit">
              {/* Animated blob - centered on phone */}
              <motion.div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-0 pointer-events-none" style={{
              backgroundColor: "#0c97a9"
            }} initial={{
              width: "250vmax",
              height: "250vmax",
              borderRadius: "50%"
            }} animate={{
              width: "420px",
              height: "420px",
              borderRadius: "50%"
            }} transition={{
              duration: 1.5,
              ease: [0.22, 1, 0.36, 1],
              delay: 0.1
            }} />
              
              {/* Phone - z-10 to stay above blob */}
              <div className="relative flex-shrink-0 drop-shadow-2xl z-10" style={{
              transform: "scale(0.78)"
            }}>
                <PhoneMockup />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}